/**
 * Extracts the legacy numeric product id embedded at the end of a product's URL slug
 * (e.g. ".../biscuit-anti-gaspi-chocolat-coco-4030234" -> 4030234). Used wherever only a
 * product's path is available but a numeric id is needed (e.g. /api/products/{id}).
 */
export const parseLegacyProductId = (path: string): number | null => {
  const id = Number.parseInt(path.split('/').at(-1)!.split('-').at(-1)!, 10);
  return Number.isNaN(id) ? null : id;
};
